import api from '../api/axios';

const getAll = (status) => {
  const url = status ? `/low-price-requests?status=${encodeURIComponent(status)}` : '/low-price-requests';
  return api.get(url);
};

const getPendingCount = () => {
  return api.get('/low-price-requests/pending-count');
};

const approve = (id) => {
  return api.post(`/low-price-requests/${id}/approve`);
};

const decline = (id) => {
  return api.post(`/low-price-requests/${id}/decline`);
};

const lowPriceRequestsServices = {
  getAll,
  getPendingCount,
  approve,
  decline,
};

export default lowPriceRequestsServices;
